// extracted by mini-css-extract-plugin
module.exports = {"searchbar":"searchbar_searchbar__1RQ9S","heading":"searchbar_heading__2LLm1","tagline":"searchbar_tagline__354dV","categories":"searchbar_categories__Ynqqi"};